module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-ir-calendar-6524d218933a67f2885d7517a8a4494d.svg";